import { createSelector, createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
    name: "issues",
    initialState: {
        list: [],
        loading: false,
        lastFetch: null,
        messages: [],
        devOpsSendStatus: false,
        allIssues: null,
    },
    reducers: {
        issuesRececeived: (issues, action) => {
            issues.allIssues = action.payload;
            issues.devOpsSendStatus = false;
        },
        issuesMessageReceived: (issues, action) => {
            issues.messages = action.payload;
        },
        addNewIssue: (issues, action) => {
            issues.list.push(action.payload);
        },
        addNewMessage: (issues, action) => {
            issues.messages.push(action.payload);
        },
        issueSentDevOps: (issues, action) => {
            issues.devOpsSendStatus = action.payload
        },
        exportingDocument: (issue, action) => {
            const url = window.URL.createObjectURL(action.payload);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "test.png");
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }
    }
});

const addIssues = "Issue/AddNewIssue";
const forwardIssues = "Issue/ForwardIssueToDevOps";
const loadIssue = "Issue/AllIssues";
const loadIssueByFilter = "Issue/GetAllIssuesByFilter";
const addMsg = "Issue/AddSupportMessage";
const loadMessages = "Issue/GetDiscussionMessages";
const notifyUser = "Issue/NotifyPortalUser";
const closedTicket = "Issue/ClosedIssueTicket";

export const { issuesRececeived, addNewIssue, addNewMessage,
    issuesMessageReceived, exportingDocument, issueSentDevOps } = slice.actions;
export default slice.reducer;


export const addIssue = issue => apiCallBegan({
    url: addIssues,
    method: "post",
    data: issue,
    onSuccess: addNewIssue.type,
});


export const forwardIssue = issue => apiCallBegan({
    url: forwardIssues,
    method: "post",
    data: issue,
    onSuccess: issueSentDevOps.type,
});

export const loadIssues = (pageSize, pageIndex, clientId) => apiCallBegan({
    url: loadIssue + "?pageSize=" + pageSize + "&pageIndex=" + pageIndex + "&clientId=" + clientId,
    onSuccess: issuesRececeived.type
})

export const loadIssuesByfilter = (data) => apiCallBegan({
    url: loadIssueByFilter,
    method: "post",
    data: data,
    onSuccess: issuesRececeived.type
})

export const loadIssuesMessages = (id) => apiCallBegan({
    url: `${loadMessages}?id=${id}`,
    onSuccess: issuesMessageReceived.type
})

export const sendMessage = message => apiCallBegan({
    url: addMsg,
    method: 'post',
    data: message,
    onSuccess: addNewMessage.type
})

export const notifyPortalUser = id => apiCallBegan({
    url: notifyUser + "?id=" + id,
    method: 'put',
    //onSuccess: issuesRececeived.type
})

export const closedIssueTicket = id => apiCallBegan({
    url: closedTicket + "?id=" + id,
    method: 'put',
    //onSuccess: issuesRececeived.type
})

export const getAllIssues = createSelector(
    state => state.entities.issues,
    issues => issues.allIssues
)

export const getIssuesMessages = createSelector(
    state => state.entities.issues,
    issues => issues.messages
)

export const getDevOpsSentStatus = createSelector(
    state => state.entities.issues,
    issues => issues.devOpsSendStatus
)